var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// Copyright 2022 The Parca Authors
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
import { useRef, useState } from 'react';
import { Popover } from '@headlessui/react';
import cx from 'classnames';
import { useClickAway } from 'react-use';
import DateTimeRangePickerPanel from './DateTimeRangePickerPanel';
import DateTimeRangePickerTrigger from './DateTimeRangePickerTrigger';
import { DateTimeRange } from './utils';
var DateTimeRangePicker = function (_a) {
    var onRangeSelection = _a.onRangeSelection, range = _a.range;
    var _b = useState(false), isActive = _b[0], setIsActive = _b[1];
    var containerRef = useRef(null);
    useClickAway(containerRef, function () {
        setIsActive(false);
    });
    return (_jsx(Popover, { children: _jsxs("div", __assign({ ref: containerRef, className: "w-fit items-center" }, { children: [_jsx(DateTimeRangePickerTrigger, { range: range, isActive: isActive, onClick: function () {
                        setIsActive(!isActive);
                    } }), isActive ? (_jsx(Popover.Panel, __assign({ className: cx('absolute z-10 mt-2 w-fit rounded border shadow-lg ring-1 ring-black ring-opacity-5 dark:border-gray-600'), static: true }, { children: _jsx(DateTimeRangePickerPanel, { range: range, onChange: function (from, to) {
                            onRangeSelection(new DateTimeRange(from, to));
                            setIsActive(false);
                        } }) }))) : null] })) }));
};
export default DateTimeRangePicker;
export { DateTimeRange };
